import React from "react";
import HeaderCommon from "../components/HeaderCommon";

export default function Franchise() {
  const partners = [
    {
      logo: "/images/spyder_technosoft.png",
      name: "Spider Techno Soft Pvt. Ltd",
      description:
        "A name synonymous with innovative business solutions, Spider Techno Soft specializes in providing tailored POS and software services across multiple industries.",
    },
    {
      logo: "/images/xenia.png",
      name: "XENIA TECHNOLOGIES LLC",
      description:
        "A trusted provider of enterprise-grade business applications including ERP, CRM, and POS software, designed with flexibility and scalability to meet modern business needs.",
    },
    {
      logo: "/images/vyapar.png",
      name: "VyaparStore™",
      description:
        "The retail arm that delivers high-performance POS hardware, accessories, and consumables to businesses of all scales – now expanding through a robust franchise model.",
    },
  ];
  return (
    <>
      <HeaderCommon />
      <div className="max-container p-2">
        <div className="row d-flex align-items-stretch gx-5">
          <div className="col-lg-8 d-flex">
            <div className="w-100 bg-white d-flex flex-column justify-content-center">
              <h4 className="poppins-semibold text-30px">
                Partner with VyaparStore - Franchise Opportunity
              </h4>
              <p className="text-justify text-base poppins-medium lh-lg">
                Welcome to VyaparStore, your trusted destination for integrated
                business software and hardware solutions. As a proud brand under
                the umbrella of Spider Techno Soft and Xenia Technologies, we
                bring decades of expertise in Point-of-Sale (POS) solutions,
                enterprise software systems, and digital transformation tools.
                We invite you to join hands with us as a franchise partner and
                become a part of our rapidly growing network, delivering
                innovative and reliable business solutions to clients across
                various industries.
              </p>
            </div>
          </div>
          <div className="col-lg-4 d-flex justify-content-center">
            <img
              src="/images/franchise.png"
              className="w-100 h-100 object-fit-contain"
            />
          </div>
        </div>

        <div
          style={{ backgroundColor: "#F0F0F0" }}
          className="shadow-sm row formContainer"
        >
          <div className="col-lg-8 d-flex flex-column justify-content-center enquiryTextContainer">
            <h2 style={{ color: "#1164AF" }} className="poppins-semibold">
              Enquire Now
            </h2>
            <h3 className="tracking-widest poppins-light">
              full Potential of Our
            </h3>
            <h1 className="poppins-semibold">Franchise Opportunity</h1>
            <p className="poppins-medium lh-lg tracking-wider joinHandsText">
              Join hands with VyaparStore and step into a future of growth,
              innovation, and unlimited business possibilities. Submit your
              enquiry today!
            </p>
          </div>
          <div className="col-lg-4 position-relative formFieldContainer">
            <div className="custom-box">
              <h4 className="poppins-semibold text-center formHeadingStyle">
                Franchise Enquiry Form
              </h4>
              <form>
                <div className="d-flex flex-column mb-3">
                  <label className="formLabelStyle">Name <span style={{ color: 'red' }}>*</span></label>
                  <input
                    className="inputFieldStyle"
                    type="text"
                    placeholder="Name"
                    required
                  />
                </div>
                <div className="d-flex flex-column mb-3">
                  <label className="formLabelStyle">Email Id<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="email"
                    className="inputFieldStyle"
                    placeholder="Email id"
                    required
                  />
                </div>
                <div className="d-flex flex-column mb-3">
                  <label className="formLabelStyle">Contact Number<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="tel"
                    className="inputFieldStyle"
                    placeholder="Contact number"
                    required
                  />
                </div>
                <div className="d-flex flex-column mb-3">
                  <label className="formLabelStyle">Message</label>
                  <textarea
                    rows="4"
                    className="inputFieldStyle"
                    placeholder="Enter your message here"
                  ></textarea>
                </div>
                <button className="submitButtonStyle" type="submit">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="py-3 py-md-5 text-center">
          <h4 className="poppins-semibold text-30px">
            Why Choose VyaparStore?
          </h4>
          <p className="poppins-medium text-base lh-lg">
            VyaparStore stands at the intersection of technology, retail
            solutions, and customer satisfaction. Backed by years of industry
            experience and strategic alliances with global tech leaders, we
            provide cutting-edge solutions that simplify and enhance business
            operations for both end-users and dealers. Our strength lies not
            only in our product portfolio but also in our commitment to
            excellence in after-sales service and customer support.
          </p>
        </div>
        <div className="pt-md-4 pb-1 text-center">
          <h4 className="poppins-semibold text-30px">Our Core Offerings</h4>
          <p className="poppins-medium text-base lh-lg">
            We offer an extensive range of hardware and software products,
            customized to cater to various business sectors including Retail,
            Hospitality, Healthcare, Distribution, and E-commerce.
          </p>
        </div>
        <div className="pt-2 pb-3 pb-md-5">
          <div className="row g-4">
            <div className="col-md-6">
              <div className="p-1 p-md-4 border-blue rounded-4 shadow-sm h-100">
                <h5 className="px-4 pt-4 mb-4 poppins-semibold text-30px">
                  POS Hardware Solutions
                </h5>
                <ul className="list-unstyled poppins-medium lh-lg">
                  {[
                    "POS Machines (Windows & Android)",
                    "Android POS Mobile Devices",
                    "Barcode Printers & Scanners",
                    "Thermal & Bluetooth Printers",
                    "Plastic Card Printers",
                    "Cash Drawers & Cash Counting Machines",
                    "Weighing Scales",
                    "Access Control Devices",
                    "Paper Shredders",
                    "Self-Service Kiosks",
                    "Signage TVs, Digital Displays & Video Walls",
                    "Consumables such as Thermal Paper Rolls, Barcode Labels & Ribbons",
                  ].map((item, idx) => (
                    <li key={idx} className="mb-2 d-flex align-items-start">
                      <img
                        src="/images/element/tick.png"
                        alt="check"
                        width={20}
                        className="me-2 mt-1"
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-md-6">
              <div className="p-1 p-md-4 border-blue rounded-4 shadow-sm h-100">
                <h5 className="px-4 pt-4 mb-4 poppins-semibold text-30px">
                  Software Solutions
                </h5>
                <ul className="list-unstyled poppins-medium lh-lg">
                  {[
                    "E-Store Development: Personalized eCommerce portals with integrated Android apps",
                    "Customer Relationship Management (CRM)",
                    "Complete Business ERP Solutions",
                    "Restaurant & Food Court Management Software",
                    "Hotel & Hospitality Solutions",
                    "Medical & Pharmaceutical Software",
                    "Delivery Vansale Billing",
                    "Android-based Mobile Billing",
                  ].map((item, idx) => (
                    <li key={idx} className="mb-2 d-flex align-items-start">
                      <img
                        src="/images/element/tick.png"
                        alt="check"
                        width={20}
                        className="me-2 mt-2"
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <p className="py-4 text-center text-base poppins-medium lh-lg mb-0">
          Each of our solutions undergoes strict quality control testing to
          ensure performance, reliability, and user satisfaction. It’s this
          dedication that positions us among the best in the industry,
          particularly in after-sales service.
        </p>
        <div className="py-3 py-md-5 text-center">
          <h4 className="poppins-semibold text-30px mb-5">Associated with</h4>
          <div className="row g-4">
            {partners.map((partner, idx) => (
              <div className="col-md-4" key={idx}>
                <div className="p-4 border-blue rounded-4 h-100 shadow-sm">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="img-fluid mb-3"
                    style={{ height: "100px", objectFit: "contain" }}
                  />
                  <p className="text-muted small poppins-medium lh-lg">
                    {partner.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="py-4 text-center">
          <h4 className="poppins-semibold text-30px">
            Be a Part of Our Franchise Network
          </h4>
          <p className="poppins-medium lh-lg text-base">
            By becoming a VyaparStore franchise partner, you are not just
            joining a business – you're becoming part of a visionary ecosystem
            focused on empowering entrepreneurs, retailers, and service
            providers with smart and scalable technology.
          </p>
        </div>
        <div>
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h5 className="poppins-semibold text-30px mb-4">
                Franchise Benefits:
              </h5>
              <div className="d-flex mb-3 poppins-medium">
                <img
                  src="/images/element/tick.png"
                  alt="check"
                  className="me-2"
                />
                <span>
                  Access to a wide range of high-demand hardware & software
                  products
                </span>
              </div>
              <div className="d-flex mb-3 poppins-medium">
                <img
                  src="/images/element/tick.png"
                  alt="check"
                  className="me-2"
                />
                <span>
                  Strong brand backing from Spider Techno Soft & Xenia
                  Technologies
                </span>
              </div>
              <div className="d-flex mb-3 poppins-medium">
                <img
                  src="/images/element/tick.png"
                  alt="check"
                  className="me-2"
                />
                <span>Complete marketing & technical support</span>
              </div>
              <div className="d-flex mb-3 poppins-medium">
                <img
                  src="/images/element/tick.png"
                  alt="check"
                  className="me-2"
                />
                <span>Attractive margins and growth potential</span>
              </div>
              <div className="d-flex mb-3 poppins-medium">
                <img
                  src="/images/element/tick.png"
                  alt="check"
                  className="me-2"
                />
                <span>Training and onboarding assistance</span>
              </div>
            </div>

            <div className="col-lg-4 text-center mb-4 mb-md-0">
              <img
                src="/images/franchise_benefit.png"
                alt="Franchise Benefits"
                className="w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
